/**
 * @fileoverview DynamicContent accepts a list of children,
 * running text processing on string values while passing
 * through React components.
 */
import React from 'react'
import { replace } from 'lib/config/placeholder'
import flatten from 'lodash/flatten'

function DynamicText({ text }) {
  return (
    <div
      className="dynamic-text"
      dangerouslySetInnerHTML={{ __html: replace(text) }}
    />
  )
}

export default function DynamicContent({ className, children }) {
  let rows = flatten([].concat(children)).map((text, i) => {
    if (typeof text === 'string') {
      return <DynamicText key={i} text={text} />
    } else {
      return text
    }
  })

  return <div className={className}>{rows}</div>
}

DynamicContent.defaultProps = {
  rows: []
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/dynamic-content.js